import { useSelector } from 'react-redux';
import { getProfileName } from '@mews-commander/legacy-entities/src/ducks/profiles';
import { ApplicationState } from '@mews-commander/types';

interface ProfileNameProps {
    id: string;
}

const ProfileName: React.FC<ProfileNameProps> = ({ id }) => {
    const name = useSelector((state: ApplicationState) => getProfileName(state, { id }));

    return <span>{name}</span>;
};

export default ProfileName;
